import { Outlet, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import Header from './Header'
import Footer from './Footer'
import ScrollToTop from './ScrollToTop'
import ContactButton from './ContactButton'
import { usePageTracking } from '../../hooks/useAnalytics'

function Layout() {
  const { pathname } = useLocation()

  // Tracking Analytics sur chaque changement de page
  usePageTracking()

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
      <ScrollToTop />
      <ContactButton />
    </div>
  )
}

export default Layout
